import React, { useEffect, useState, useRef } from "react";
import { authProject } from "utils";
import { authConfig, applyStyles } from "../../utils/auth";

import UnderMaintenance from "../../components/UnderMaintenance";

import { useParams } from "react-router-dom";

import { routeProps as legalRouteProps } from "./schemaLegalPerson";
import { routeProps as personalRouteProps } from "./schemaPersonal";

import { getPaymentGroup, getItem, setItem, removeItem } from "utils";

import SignUpPersonal from "./signupPersonal";
import SignUpLegalPerson from "./signupLegalPerson";

function Signup() {
  const { paymentGroupId, type = false, currentUserId, formStep } = useParams();

  const [routeProps, setRouteProps] = useState({});
  // const [step, setStep] = useState(currentUserId ? 3 : 0);

  const [returnToken, setReturnToken] = useState(true);
  const companyName = getItem("companyName");
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [formType, setFormType] = useState("");
  const [skipPayment, setSkipPayment] = useState(null);

  useEffect(() => {
    removeItem("tk-project");
    removeItem("tk-user");
    removeItem("userEmail");
    removeItem("userPhone");
    removeItem("userId");
    removeItem("privacyPolicy");
    removeItem("termsRepresentation");
    removeItem("termsConditions");
    removeItem("companyId");
    removeItem("androidAppUrl");
    removeItem("companyName");
    removeItem("iosAppUrl");

    var subdomain = window.location.hostname;

    if (window.location.hostname === "localhost") {
      subdomain = "brm1";
    } else {
      subdomain = subdomain.match(/embed-(.*?)\./)[1];
    }

    if (type === "legalPerson") {
      setRouteProps(legalRouteProps);
    } else {
      setRouteProps(personalRouteProps);
    }

    applyStyles(subdomain).then(() =>
      authProject(authConfig).then(() => setReturnToken(false))
    );

    const event = new Event("historyChange");
    window.dispatchEvent(event);
  }, []);

  React.useEffect(() => {
    async function getPlans() {
      const companyId = await getItem("companyId");

      const {
        data: { data: dataPlans },
      } = await getPaymentGroup({
        companyId,
        id: paymentGroupId,
      });

      let paymentFrequency = dataPlans[0]?.paymentTypes[0]?.value;

      if (paymentFrequency === 0) {
        setSkipPayment(true);
      } else {
        setSkipPayment(false);
      }
    }

    getPlans();
  }, []);

  useEffect(() => {
    if (type === "person") {
      setFormType("legalPerson");
    } else {
      setFormType("personal");
    }
  }, [type]);

  return (
    <div className="__auth-background">
      {isUnderMaintenance ? (
        <UnderMaintenance></UnderMaintenance>
      ) : (
        <>
          {(type === false || type === "personal") && (
            <SignUpPersonal skipPayment={skipPayment} />
          )}
          {type === "legalPerson" && (
            <SignUpLegalPerson skipPayment={skipPayment} />
          )}
        </>
      )}
    </div>
  );
}

export default Signup;
